import { usersPatchCurrentUserAuthUsersMePatchMutation } from '@/client/@tanstack/react-query.gen'
import { ChangePasswordForm } from '@/components/change-password-form'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useSettingsSectionViewed } from '@/hooks/use-analytics'
import { useToast } from '@/hooks/use-toast'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { SettingsPageSkeleton } from './-components/skeleton'

export const Route = createFileRoute('/_authed/_user/settings/security')({
  component: SecurityPage,
  pendingComponent: SettingsPageSkeleton,
  beforeLoad: () => ({
    getTitle: () => 'Security',
    getDescription: () => 'Update your password',
  }),
})

function SecurityPage() {
  useSettingsSectionViewed('security')
  const { toast } = useToast()

  const { mutateAsync: changePassword } = useMutation({
    ...usersPatchCurrentUserAuthUsersMePatchMutation(),
    onSuccess: () => {
      toast({ title: 'Password updated', variant: 'success' })
    },
    onError: error_ =>
      toast({
        title: 'Failed to update password',
        description: error_ instanceof Error ? error_.message : 'An unexpected error occurred',
        variant: 'destructive',
      }),
  })

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle>Security</CardTitle>
        <CardDescription className="mt-1.5">
          Update your password.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChangePasswordForm
          onSubmit={async (password) => {
            await changePassword({ body: { password } })
          }}
          submitLabel="Update Password"
          submittingLabel="Updating..."
        />
      </CardContent>
    </Card>
  )
}
